/**
 * Product gallery mobile progress navigation (pill bar under the image carousel).
 */
function getVisibleNavSegments(nav) {
  return [...nav.querySelectorAll('.product-gallery__carousel-navigation-segment')].filter(
    (segment) => !segment.hasAttribute('hidden')
  );
}

function updateProductGalleryCarouselNavigation(nav, index) {
  const segments = getVisibleNavSegments(nav);
  const count = segments.length;

  nav.hidden = count <= 1;

  if (!count) return;

  nav.dataset.slideCount = String(count);
  nav.style.setProperty('--product-gallery-nav-progress', (index + 1) / count);
}

function initProductGalleryCarouselNavigation(nav) {
  if (nav.dataset.mmkNavInit === 'true') return;
  nav.dataset.mmkNavInit = 'true';

  const carousel = document.getElementById(nav.getAttribute('aria-controls'));
  if (!carousel) return;

  const syncFromCarousel = () => {
    updateProductGalleryCarouselNavigation(nav, carousel.selectedIndex ?? 0);
  };

  syncFromCarousel();

  carousel.addEventListener('carousel:change', (event) => {
    updateProductGalleryCarouselNavigation(nav, event.detail.index);
  });

  carousel.addEventListener('carousel:filter', () => {
    queueMicrotask(syncFromCarousel);
  });

  carousel.addEventListener('carousel:settle', syncFromCarousel);
}

function initProductGalleryCarouselNavigations(root = document) {
  root.querySelectorAll('.product-gallery__carousel-navigation').forEach(initProductGalleryCarouselNavigation);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductGalleryCarouselNavigations());
} else {
  initProductGalleryCarouselNavigations();
}

document.addEventListener('shopify:section:load', (event) => {
  initProductGalleryCarouselNavigations(event.target);
});

document.addEventListener('product:rerender', (event) => {
  const rerenderRoot = event.target?.closest?.('product-rerender');
  initProductGalleryCarouselNavigations(rerenderRoot || document);
});
